// extracted by mini-css-extract-plugin
module.exports = {"flex":"async-flex-element_flex__2klXA","fadeIn":"async-flex-element_fadeIn__ATKy7","hasLoaded":"async-flex-element_hasLoaded__3JOiP","fadeOut":"async-flex-element_fadeOut__1M9bf"};